export const menuData = [
  { title: 'Home', link: '/#' },
  { title: 'Goals', link: '/#goals' },
  { title: 'Stats', link: '/#stats' },
  { title: 'Reviews', link: '/#review' },
  { title: 'FAQs', link: '/#faqs' },
];

export const about = [
  { title: 'Projects', link: '/#' },
  { title: 'Our Team', link: '/#' },
];

export const support = [
  { title: 'Support Request', link: '/#' },
  { title: 'Contact', link: '/#' },
];
